<template>
  <div>
    <user-card v-if="shipping.courier_id" :user="courier || shipping.courier" />
    <b-form @submit.prevent v-else-if="isAssignable">
      <b-form-row>
        <div class="form-group col-12" v-if="!courier || !courier.id || (!courier && !shipping.courier_id) || shipping.courier_id === courier.id">
          <user-autocomplete ref="courierAc" :endpoint="endpoint" @selected="onSearchCourierSelected" :placeholder="this.$gettext('Courier name or email')" :restrictToRoles="['courier']" with-picture />
        </div>
        <div class="form-group col-12" v-if="courier && courier.id && shipping.courier_id !== courier.id">
          <user-card :user="courier" :with-titles="false" :with-map="false" />
        </div>
        <div class="form-group col-12">
          <div class="input-group">
            <b-btn size="sm" v-if="courier" @click="assignShipping(shipping.id)" :disabled="!courier.id || shipping.courier_id === courier.id" v-translate>Assign!</b-btn>
            <b-btn variant="warning" size="sm" v-if="allowResetCourier && courier && courier.id && shipping.courier_id !== courier.id" @click="courier = null; shipping.courier_id = null;" :disabled="!courier.id" class="ml-1" v-translate>Search again</b-btn>
          </div>
        </div>
      </b-form-row>
    </b-form>
    <b-alert variant="warning" show v-else v-translate>This shipment cannot be assigned to a courier.</b-alert>
  </div>
</template>

<script>
import { ShippingService } from '@/services/api'
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
import ShippingAssignMixin from '@/mixins/shippingAssign.mixin'

export default {
  name: 'EditFieldCourier',
  components: {
    UserAutocomplete
  },
  mixins: [ShippingAssignMixin],
  props: {
    shipping: {
      type: Object,
      required: true
    },
    allowResetCourier: {
      type: Boolean,
      default: true
    },
    endpoint: {
      type: String,
      default: 'users'
    }
  },
  data() {
    return {
      courier: null
    }
  },
  computed: {
    isEditable() {
      return this.shipping.company &&
        this.shipping.status !== 'DELIVERED' &&
        this.shipping.status !== 'CANCELED' &&
        this.shipping.status !== 'RETURNED'
    },
    isAssignable() {
      return this.isCarrierAssignable(this.shipping)
    }
  },
  methods: {
    setCourier(element) {
      this.courier = element
    },
    onSearchCourierSelected(item) {
      this.courier = item
      this.$refs.courierAc.searchQuery = ''
    },
    assignShipping(id) {
      this.assignShippingToCourier(id, this.courier.id)
        .then(() => {
          // Already assigned: a failed re-read falls back to what was just sent
          return ShippingService.get(id, { params: { includes: ['courier'] }, skipErrorAlert: true })
            .then(response => response.body, () => ({ courier_id: this.courier.id, courier: this.courier, status: 'CONFIRMED' }))
        })
        .then(shipping => {
          this.$emit('success', shipping)
        }, error => {
          this.showAssignError(error)
        })
    }
  }
}
</script>
